import * as React from "react"
import LocationSvg from "../images/location-dot-solid.svg"
import { Link, useI18next, Helmet, Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import PhoneSvg from "../images/phone-solid.svg"
import ChevronDownSvg from "../images/chevron-down.svg"
import { graphql } from "gatsby"
import { useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import EnvelopeSvg from "../images/envelope-solid.svg"

const navLinkFactory = (t) => [
  {
    link: t('Find-us'),
    title: t('Find us'),
    image: <LocationSvg width="22" height="22"/>
  },
  {
    link: t('Contact'),
    title: t('Contact'),
    image: <PhoneSvg width="22" height="22"/>
  }
]

const Navigation = () => {
  const { t } = useTranslation()
  const { languages, originalPath, language } = useI18next();
  const [ isLanguageDropdownOpen, setLanguageDropdownOpen ] = useState(false)
  const navLinks = navLinkFactory(t)

  return (<nav className="w-screen sm:flex sm:justify-center fixed top-0 z-50">
    <div className="flex mx-auto items-center sm:space-x-10 sm:justify-center border-b shadow-md shadow-md p-2 bg-white">
      <div className="flex space-x-4 items-center">
        <a href="/">
          <StaticImage src="../images/icon.png" alt={t('Logo')} width={50} height={35}/>
        </a>
        {navLinks.map(({ link, title, image }) =>(<a key={link} href={`#${link}`} className="flex space-x-0.5 hover:text-yellow-400">
          {image}
          <span>{title}</span>
        </a>))}
      </div>
      <ul className="hidden md:flex ml-auto">
        { languages.map((lng) => (<li key={lng} className="border-r border-black pr-1 pl-1 last:border-r-0 last:border-none">
          <Link to={originalPath} language={lng} className="hover:text-yellow-400">
            {lng}
          </Link>
        </li>)) }
      </ul>
      <div className="relative inline-block text-left block md:hidden ml-auto">
        <div>
          <button type="button" onClick={() => setLanguageDropdownOpen(!isLanguageDropdownOpen)} className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-2 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500" id="menu-button" aria-expanded="true" aria-haspopup="true">
            {language}
            <ChevronDownSvg className="-mr-0.5 ml-0.5 h-5 w-5"/>
          </button>
        </div>
        {isLanguageDropdownOpen && <div className="origin-top-right absolute right-0 w-20 text-center rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
          <div className="py-1 flex flex-col" role="none">
            {languages
              .filter((lng) => lng !== language)
              .map((lng) => <Link key={`${lng}-mobile`} to={originalPath} language={lng}>
                {lng}
              </Link>)}
          </div>
        </div>}
      </div>
    </div>
  </nav>)
}

const IndexPage = () => {
  const { t } = useTranslation()
  const businessDateStart = new Date("2007-03-20")
  const businessDateDiffMs = new Date() - businessDateStart
  const businessDateAge = new Date(businessDateDiffMs)
  const businessYears = Math.abs(businessDateAge.getUTCFullYear() - 1970)
  const navLinks = navLinkFactory(t)
  const { language } = useI18next();

  return (
    <main>
      <Helmet>
        {/* to test configuration see https://search.google.com/test/rich-results */}
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "Person",
          "url": "https://www.zardukas.lt",
          "name": "Zardukas",
          "address": {
              "@type": "PostalAddress",
              "streetAddress": "Terminalo g. 6",
              "addressLocality": "Kaunas",
              "postalCode": "54469",
              "addressCountry": "LT"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+370 656 68555",
            "contactType": "SEO",
            "email": "audrius@zardukas.lt"
          },
          "telephone": "+370 656 68555"
        }
      `}
        </script>
        <html className="scroll-smooth" lang={language}/>
        <title>{t('Customs broker Zardukas')}</title>
        <meta name="description" content={t('Customs broker in Kaunas')}/>

        <meta property="og:title" content={t('Customs broker Zardukas')} />
        <meta property="og:description" content={t('Customs broker Zardukas')}/>

      </Helmet>
      <Navigation/>
      <section className="flex flex-col shadow-lg relative">
        <StaticImage
          src="../images/hero.jpg"
          alt={t('Cargo')}
          placeholder="blurred"
          layout="fullWidth"
        />
        <h1 className="text-3xl md:text-4xl lg:text-6xl text-center p-4 font-bold md:absolute md:top-1/4 md:left-1/2 md:-translate-x-1/2 md:translate-y-1/4">
          Žardukas, UAB
        </h1>
        <h2 className="text-2xl md:text-2xl lg:text-3xl text-center p-4 font-bold md:absolute md:top-1/3 md:left-1/2 md:-translate-x-1/2 md:translate-y-1/4">
          {/* @see pluralization https://jsfiddle.net/6bpxsgd4 */}
          <Trans i18nKey="subTitle">
            Customs broker located in Kaunas since <time>{{ businessYears: t('year', { count: businessYears }) }}</time>
          </Trans>
        </h2>
      </section>
      <section id={navLinks[0].link} className="bg-gray-300">
        <div className="container mx-auto">
          <div className="flex items-center justify-center pt-10 pb-10">
            <div className="bg-white rounded-lg shadow-xl border p-8 w-11/12 md:w-1/2">
              <div className="mb-4">
                <h3 className="font-semibold text-gray-800">{t('Find us')}</h3>
              </div>
              <div className="mb-8 flex justify-center">
                <iframe
                  title={t('Find us')}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3637.891631899425!2d24.009448060366218!3d54.94278770887365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46e719bacbd7592f%3A0x235e545ca6906aac!2sTerminalo%20g.%206%2C%2054469!5e0!3m2!1slt!2slt!4v1645042546859!5m2!1slt!2slt"
                  width="600" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy"/>
              </div>
              <address className="flex">
                Terminalo g. 6,
                54469,
                Kaunas,
                {t('Lithuania')}
              </address>
            </div>
          </div>
        </div>
      </section>
      <section id={navLinks[1].link} className="shadow-lg relative">
        <div className="container mx-auto">
          <div className="flex items-center justify-center pt-10 pb-10">
            <div className="bg-white rounded-lg shadow-xl border p-8 w-11/12 md:w-1/2">
              <div className="mb-4">
                <h3 className="font-semibold text-gray-800">{t('Contact')}</h3>
              </div>
              <div className="mb-8">
                <a href="tel:+370 656 68555" className="flex items-center space-x-1 hover:text-yellow-400">
                  <PhoneSvg width={40} height={40}/>
                  <span>
                    +370 656 68555
                  </span>
                </a>
              </div>
              <div>
                <a href="mailto:audrius@zardukas.lt" className="flex items-center space-x-1 hover:text-yellow-400">
                  <EnvelopeSvg width={40} height={40}/>
                  <span>
                    audrius@zardukas.lt
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default IndexPage

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
